import { render, staticRenderFns } from "./NewNotification.vue?vue&type=template&id=7c907e52&scoped=true&"
import script from "./NewNotification.vue?vue&type=script&lang=js&"
export * from "./NewNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewNotification.vue?vue&type=style&index=0&id=7c907e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c907e52",
  null
  
)

export default component.exports